import React from 'react'
import { unreadNumberLabel } from 'frontend_core/dist/helpers/format'

type PropTypes = {
  announcements: Array<Object>,
  todoItems: Array<Object>,
  notificationItems: Array<Object>,
  onMobileDrawer: Boolean,
}

class BadgeView extends React.Component {
  constructor(props: PropTypes) {
    super(props)
  }

  renderMobileBadge(label) {
    if (!label) {
      label = <i className="fa fa-exclamation" />
    }
    return <span className="site-header__drawer-menu-bagde">{label}</span>
  }

  renderDesktopBadge(label) {
    if (label) {
      return <span className="site-header__nav-bagde">{label}</span>
    } else if (
      this.props.newsNumber === 0 &&
      (this.props.todoItems.length > 0 || this.props.announcements.length > 0)
    ) {
      return (
        <span className="site-header__nav-bagde">
          <i className="fa fa-exclamation" />
        </span>
      )
    }
    return null
  }

  render() {
    const label = unreadNumberLabel(this.props.newsNumber)

    if (this.props.onMobileDrawer) {
      return this.renderMobileBadge(label)
    } else {
      return this.renderDesktopBadge(label)
    }
  }
}

export default BadgeView



// WEBPACK FOOTER //
// ./src/components/shared/header/BadgeView.jsx